<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalDrainage from "../DesignerQuestionTechnicalDrainage.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalDrainage
        ],
        props: {
            typeRange: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.cill, this.threshold, this.typeRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-drainage?cill=' + this.cill + '&threshold=' + this.threshold + '&type_range=' + this.typeRange;
            },
            cache_key(){
                return '_' + this.cill + '_' + this.threshold + '_' + this.typeRange;
            }
        },
        watch: {
            'cill': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
            'threshold': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
            'typeRange': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
        }
    }
</script>
